import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { newsList } from "@/mocks/news";

export default function NewsPreview() {
  const [featured, ...rest] = newsList;

  return (
    <section className="mx-auto max-w-[1280px] px-4 py-10 md:px-8 md:py-14">
      <SectionHeading
        title="精选影视资讯"
        subtitle="了解行业动态、幕后故事与深度剧评"
        icon="ri-newspaper-line"
        moreTo="/news"
        moreLabel="进入资讯频道"
      />

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-6">
        <Link
          to={`/news/${featured.id}`}
          className="group relative overflow-hidden rounded-lg border border-background-200/60 animate-fade-up"
        >
          <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-200">
            <img
              src={featured.cover}
              alt={featured.title}
              title={`${featured.title}-榴莲视频资讯`}
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/40 to-transparent"></div>
          </div>
          <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
            <span className="rounded-md bg-accent-500 px-2 py-0.5 text-xs text-background-50">
              {featured.category}
            </span>
            <h3 className="mt-2 dv-clamp-2 font-heading text-lg font-bold text-foreground-950 md:text-xl">
              {featured.title}
            </h3>
            <p className="mt-2 dv-clamp-2 text-sm text-foreground-400">{featured.summary}</p>
          </div>
        </Link>

        <div className="flex flex-col divide-y divide-background-200/60 rounded-lg border border-background-200/60 bg-background-100/40 animate-fade-up delay-2">
          {rest.slice(0, 6).map((item) => (
            <Link
              key={item.id}
              to={`/news/${item.id}`}
              className="group flex items-center gap-4 p-4 transition-colors hover:bg-background-200/40 cursor-pointer"
            >
              <div className="min-w-0 flex-1">
                <h4 className="dv-clamp-1 text-sm font-medium text-foreground-900 transition-colors group-hover:text-accent-500">
                  {item.title}
                </h4>
                <p className="mt-1 dv-clamp-1 text-xs text-foreground-300">
                  <i className="ri-time-line mr-1"></i>
                  {item.date} · {item.source}
                </p>
              </div>
              <i className="ri-arrow-right-s-line shrink-0 text-lg text-foreground-300 transition-colors group-hover:text-accent-500"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}